module.exports = __webpack_public_path__ + "img/avator2.ec83a71d.png";